<app-shared-engagement-table
  [engagementList]="engagementList"
  [isPoeInvoice]="isPoeInvoice"
  [prevDocumentType]="prevDocumentType"
  [loading]="loading"
  (refreshList)="
    initializeInvoiceDocReviewList()
  "></app-shared-engagement-table>
